module.exports = __webpack_public_path__ + "img/DCHQ.0696d9af.svg";